import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAirpodLeft: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="airpod-left"><path d="M7.75 12.8984V20.25H4.75V8.5C4.75 5.87669 6.90855 3.75007 9.57129 3.75C10.5624 3.75 11.4839 4.04459 12.25 4.5498V12.4492C11.4838 12.9546 10.5626 13.25 9.57129 13.25C8.92672 13.25 8.31201 13.1246 7.75 12.8984ZM7.75 12.8984V11" stroke="currentColor" strokeWidth="1.5"/><path d="M15.75 13V20.25H20" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconAirpodLeft;
